import React from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/management/edit.svg";
import { ReactComponent as BoxingIcon } from "../../assets/icons/table/boxing.svg";
import { IPhoneOrder } from "../../types/phoneOrder.type";
import { formatDate, formatTime } from "../../utils/formatDate";
import PaymentStatusComponent from "../PaymentStatus/PaymentStatus";
import styles from "./styles.module.scss";

interface Props {
  orders: IPhoneOrder[];
  callBackEdit: (user: IPhoneOrder) => void;
  callBackAddWithdraw: (order: IPhoneOrder) => void;
}

const PhoneOrderTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Date</th>
          <th>Contacts</th>
          <th>Invoice</th>
          <th>Сума</th>
          <th>Satus</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.orders &&
          props.orders.map((user, index) => (
            <tr key={user.id}>
              <td>
                <div className={styles.userInfo}>
                  <div className={styles.dateContainer}>
                    <span>{formatDate(user.createdAt)}</span>
                    <span>{formatTime(user.createdAt)}</span>
                  </div>
                </div>
              </td>
              <td className={styles.role}>
                <div className={styles.nameContainer}>
                  <span className={styles.name}>{user.client.fullName}</span>
                  <span className={styles.email}>{user.client.phone}</span>

                  <span className={styles.email}>{user.client.email}</span>
                </div>
              </td>
              <td className={styles.role}>{user.invoice}</td>
              <td className={styles.role}>
                {user.totalAmount != null && String(user.totalAmount).trim() !== ""
                  ? `${user.totalAmount} €`
                  : "—"}
              </td>
              <td>
                <PaymentStatusComponent status={user.status} />
              </td>
              <td>
                <div className={styles.actions}>
                  <button
                    type="button"
                    className={styles.editBtn}
                    title="Редагувати замовлення"
                    aria-label="Редагувати замовлення"
                    onClick={() => props.callBackEdit(user)}
                  >
                    <EditIcon />
                  </button>
                  {user.status === "paid" && (
                    <button
                      type="button"
                      className={styles.editBtn}
                      title="Упаковка / списання"
                      aria-label="Упаковка"
                      onClick={() => props.callBackAddWithdraw(user)}
                    >
                      <BoxingIcon />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default PhoneOrderTable;
